export const mockData = {
  services: [
    {
      id: 1,
      title: "High-Speed Internet",
      description: "Experience blazing-fast fiber internet with speeds up to 1 Gbps. Perfect for streaming, gaming, and working from home.",
      icon: "wifi",
      features: [
        "Up to 1 Gbps speeds",
        "99.9% uptime guarantee",
        "Unlimited data",
        "Free router included",
        "24/7 customer support"
      ]
    },
    {
      id: 2,
      title: "OTT IPTV",
      description: "Access 500+ live channels and premium OTT apps. Entertainment for the whole family with HD and 4K quality.",
      icon: "tv",
      features: [
        "500+ live TV channels",
        "Premium OTT apps included",
        "HD & 4K streaming",
        "Multi-device support",
        "On-demand content library"
      ]
    },
    {
      id: 3,
      title: "Roaming WiFi",
      description: "Access free public WiFi hotspots across the city, state, or anywhere i5World is available. Use your home broadband plan on the go through our captive portal network.",
      icon: "router",
      features: [
        "Public WiFi hotspots at all i5World locations",
        "Use your home plan anywhere",
        "Seamless captive portal login",
        "Available across cities and states",
        "No additional charges"
      ]
    }
  ],

  plans: [
    {
      id: 1,
      name: "Starter",
      speed: "30 Mbps",
      data: "Unlimited",
      popular: false,
      features: [
        "Ideal for browsing & streaming",
        "Unlimited data usage",
        "Connect multiple devices",
        "Free router",
        "Free installation",
        "OTT IPTV apps included",
        "Roaming WiFi access"
      ]
    },
    {
      id: 2,
      name: "Family Pro",
      speed: "100 Mbps",
      data: "Unlimited",
      popular: true,
      features: [
        "Perfect for families",
        "Unlimited data usage",
        "HD & 4K streaming",
        "Free mesh router",
        "Free installation",
        "Premium OTT IPTV apps",
        "Roaming WiFi access",
        "Priority customer support"
      ]
    },
    {
      id: 3,
      name: "Ultra Speed",
      speed: "300 Mbps",
      data: "Unlimited",
      popular: false,
      features: [
        "Lightning-fast connectivity",
        "Unlimited data usage",
        "Multiple 4K streams",
        "Free mesh router system",
        "Free installation",
        "All premium OTT IPTV apps",
        "Roaming WiFi access",
        "Dedicated support"
      ]
    },
    {
      id: 4,
      name: "Gigabit Elite",
      speed: "1 Gbps",
      data: "Unlimited",
      popular: false,
      features: [
        "Maximum performance",
        "Unlimited data usage",
        "Enterprise-grade speed",
        "Free mesh router system",
        "Free installation",
        "All premium OTT IPTV apps",
        "Roaming WiFi access",
        "Static IP available",
        "Dedicated support manager"
      ]
    }
  ],

  testimonials: [
    {
      id: 1,
      name: "Rajesh Patel",
      role: "Software Engineer",
      location: "Ahmedabad",
      rating: 5,
      comment: "i5World's internet service is incredibly fast and reliable. Perfect for my work-from-home needs. The customer support is also excellent!"
    },
    {
      id: 2,
      name: "Priya Shah",
      role: "Content Creator",
      location: "Surat",
      rating: 5,
      comment: "The OTT IPTV service has transformed our family entertainment. 500+ channels and all the streaming apps we need. Highly recommended!"
    },
    {
      id: 3,
      name: "Amit Desai",
      role: "Business Owner",
      location: "Vadodara",
      rating: 5,
      comment: "The Roaming WiFi feature is amazing! I can use my home plan at any i5World hotspot across the city. No extra charges, just seamless connectivity."
    },
    {
      id: 4,
      name: "Sneha Mehta",
      role: "Student",
      location: "Rajkot",
      rating: 5,
      comment: "The internet speed is amazing! I can attend online classes, stream videos, and game without any lag. Best decision ever!"
    }
  ],

  faqs: [
    {
      id: 1,
      question: "What internet speeds does i5World offer?",
      answer: "We offer a range of speeds from 50 Mbps to 1 Gbps, designed to meet various needs from basic browsing to heavy streaming and gaming."
    },
    {
      id: 2,
      question: "Is there a data limit on your plans?",
      answer: "All our plans come with truly unlimited data with no fair usage policy. Stream, download, and browse as much as you want without any restrictions."
    },
    {
      id: 3,
      question: "What OTT apps are included with IPTV?",
      answer: "Our IPTV service includes popular OTT apps like Netflix, Amazon Prime, Disney+ Hotstar, Zee5, Sony Liv, and many more."
    },
    {
      id: 4,
      question: "How does Roaming WiFi work?",
      answer: "Roaming WiFi allows you to access public WiFi hotspots at any i5World broadband location. Simply connect to the hotspot, login through our captive portal with your credentials, and use your home plan's data anywhere i5World is available - across the city, state, or country. No additional charges apply."
    },
    {
      id: 5,
      question: "Do you provide installation support?",
      answer: "Yes, we provide free installation for all our plans. Our technical team will visit your location and set up everything for you."
    },
    {
      id: 6,
      question: "What is your customer support availability?",
      answer: "We offer 24/7 customer support via phone, email, and chat. Our team is always ready to assist you with any queries or issues."
    }
  ],

  features: [
    {
      id: 1,
      title: "Lightning Fast Speeds",
      description: "Experience internet speeds up to 1 Gbps with our fiber-optic network",
      icon: "zap"
    },
    {
      id: 2,
      title: "99.9% Uptime",
      description: "Reliable connection you can count on, every single day",
      icon: "shield-check"
    },
    {
      id: 3,
      title: "24/7 Support",
      description: "Round-the-clock customer support ready to help you anytime",
      icon: "headphones"
    },
    {
      id: 4,
      title: "Easy Installation",
      description: "Free professional installation with all our plans",
      icon: "wrench"
    }
  ]
};
